module.exports = __webpack_public_path__ + "media/images/techno_logo_black-e62a2e67.svg";